export default "__VITE_ASSET__DyEGTNry__"